import styled, {css} from 'styled-components'
import {Container} from '../../../components/container/Container'

export const PartnersWrapper = styled(Container)`
    ${({theme: {spacing}}) => css`
        padding-top: ${spacing * 15}px;
        padding-bottom: ${spacing * 15}px;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        overflow: hidden;
        gap: ${spacing * 8}px;
    `}
`

export const StyledHeadingPartner = styled.div`
    ${({theme: {typography, colors}}) => css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        & h1 {
            ${typography.displayXs};
            font-weight: 600;
            color: ${colors.lightBlack};
        }
    `}
`

export const StyledActions = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        align-items: center;
    `}
`

export const ImpersonationOverlay = styled.div`
    ${({theme: {typography}}) => css`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;

        & > div {
            text-align: center;
            color: white;

            & h2 {
                ${typography.displaySm};
                font-weight: 600;
                margin: 0;
            }
        }
    `}
`

export const StyledReasonText = styled.span`
    ${({theme: {typography}}) => css`
        ${typography.textSm};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
    `}
`
